<template>
  <div id="app">
    <router-view />
    <BindPhoneDialog v-if="token" />
  </div>
</template>

<script>
import BindPhoneDialog from '@/components/BindPhoneDialog.vue'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: { BindPhoneDialog },
  computed: {
    ...mapState(['token'])
  },
  created() {
    if (this.token) {
      this.$store.dispatch('initUserInfo').catch(() => {})
    }
  }
}
</script>

<style lang="scss">
img {
  vertical-align: middle;
}
body {
  padding: 0;
  margin: 0;
}

#app {
  font-family: Source Han Sans CN;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #333;
  font-size: 16px;
}

a,
.router-link {
  text-decoration: none;
  color: #333;
}

.popover-content {
  .info {
    font-size: 14px;
    color: #999;
    &-title {
      margin-bottom: 5px;
      font-size: 18px;
      color: #42a747;
      font-weight: bold;
      text-align: center;
    }
  }
}
.farm-detail-body-main {
  img {
    max-width: 100%;
  }
}
</style>

<style lang="scss" scoped>
@import "~@/style/variables.scss";

// ::v-deep .el-form-item {
//     margin-bottom: 40px;
//     font-size: 22px;
// }

// ::v-deep .el-form-item__label {
//     font-size: 22px;
//     padding-right: 80px;
// }

// ::v-deep .el-form-item__content {
//     font-size: 22px;
// }

// ::v-deep .el-input__inner {
//     height: 60px;
//     line-height: 60px;
//     font-size: 22px;
//     border-radius: 0;
// }

// ::v-deep .el-input-number  {
//     &.is-controls-right{
//         .el-input-number__decrease,.el-input-number__increase{
//             line-height: 28.5px;
//         }
//     }
//     .el-input-number__decrease,.el-input-number__increase{
//         line-height: 58px;
//     }
// }

// ::v-deep .el-button {
//     font-size: 22px;
// }

// ::v-deep .el-button--primary{
//     background-color: $--color-primary;
// }

// ::v-deep .el-checkbox {
//     font-size: 24px;
// }

// ::v-deep .el-checkbox__label {
//     font-size: 22px;
//     line-height: 40px;
// }

// ::v-deep .el-checkbox__inner {
//     width: 24px;
//     height: 24px;

//     &::after {
//         left: 7px;
//         width: 8px;
//         height: 12px;
//     }
// }

//表格
::v-deep .el-table {
  border: 2px solid $--color-primary;
  font-size: 20px;

  th.el-table__cell {
    line-height: 40px;
    background-color: rgba($--color-primary, 0.1);
    font-weight: normal;
  }

  thead {
    color: #333;
  }
}

// ::v-deep .el-link{
//     font-size: 20px;
// }
</style>
